import * as moment from "moment";
export class Placa {
  id: string;
  bastidor: string;
  importador: string;
  tipoSolicitud: string;
  fechaCreacion: string;
  analista: string;
  estado: string;
  comentarios: string;
  fechaRealizacion: string;

  static placaFromJson(obj: Object) {
    let tcertificado = obj["tipoReforma"]
      ? obj["tipoCertificado"] + " " + obj["tipoReforma"]
      : obj["tipoCertificado"];
    return new Placa(
      obj["solicitud"],
      obj["bastidor"],
      obj["importador"],
      tcertificado,
      moment(obj["fechaCreacion"]).format("DD/MM/yyyy"),
      obj["usuario"],
      obj["estado"],
      obj["comentarios"],
      obj["fechaEstado"] ? moment(obj["fechaEstado"]).format("DD/MM/yyyy") : ""
    );
  }

  constructor(
    id: string,
    peBastidor: string,
    importador: string,
    tipoSolicitud: string,
    peCreacion: string,
    usuario: string,
    estado: string,
    comentarios: string,
    fechaRealizacion: string
  ) {
    this.id = id;
    this.bastidor = peBastidor;
    this.importador = importador;
    this.tipoSolicitud = tipoSolicitud;
    this.fechaCreacion = peCreacion;
    this.analista = usuario;
    this.estado = estado;
    this.comentarios = comentarios;
    this.fechaRealizacion = fechaRealizacion;
  }
}
